import { render, staticRenderFns } from "./editOwner2.vue?vue&type=template&id=64f25b5b&scoped=true&"
import script from "./editOwner2.vue?vue&type=script&lang=js&"
export * from "./editOwner2.vue?vue&type=script&lang=js&"
import style0 from "./editOwner2.vue?vue&type=style&index=0&id=64f25b5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f25b5b",
  null
  
)

export default component.exports